import _get from "lodash/get";
import styled from 'styled-components';
import typographyTheme from '../styles/typographyTheme';
import smallStyles from '../styles/smallStyles';
var SmallNote = styled.small.withConfig({
  displayName: "SmallNote",
  componentId: "c0eoh8-0"
})(["", " color:", ";"], smallStyles, function (_ref) {
  var theme = _ref.theme,
      colorValue = _ref.colorValue;
  return _get(theme, "typography.colors." + colorValue, typographyTheme.typography.colors[colorValue]);
});
export default SmallNote;